<template>
  <div id="index">
    <el-container>
      <el-container>
        <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
          <el-main class="index">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="mainBread">
              <el-breadcrumb-item :to="{ path: '/client/default' }">{{ $t("menu.Home_View") }}</el-breadcrumb-item>
              <el-breadcrumb-item>{{ $t('desc.changePaw') }}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-form ref="pawform" :model="pawform" label-width="30%" class="queryform_div" :rules="rules">
              <el-form-item :label="$t('title.account')">
                <el-input :disabled="true" v-model="pawform.username" style="max-width: 300px">
                </el-input>
              </el-form-item>
              <el-form-item prop="currentPassword" :label="$t('title.enterOriginalPwd')">
                <el-input :placeholder="$t('title.enterOriginalPwd')" show-password v-model="pawform.currentPassword"
                  style="max-width: 300px"></el-input>
              </el-form-item>
              <el-form-item prop="newPassword" :label="$t('title.setNewPwd')">
                <el-input :placeholder="$t('title.setNewPwd')" show-password v-model="pawform.newPassword"
                  style="max-width: 300px"></el-input>
              </el-form-item>
              <el-form-item prop="newPassword2" :label="$t('title.setNewPwdAgain')">
                <el-input :placeholder="$t('title.setNewPwdAgain')" show-password v-model="pawform.newPassword2"
                  style="max-width: 300px"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="onSubmit('pawform')" type="primary">{{ $t("button.confirm") }}</el-button>
                <el-button @click="back">{{ $t("button.cancel") }}</el-button>
              </el-form-item>
            </el-form>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import {
  delItemFormLocalstorage,
  getItemFormLocalstorage,
} from "../../../utils/package-localstorage";
import { changePassword } from "../../api/api";
import { mapState } from "vuex";

export default {
  name: "index",
  data() {
    var validatePass1 = (rule, value, callback) => {
      var yanzheng = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,}$/.test(
        value
      );
      if (value === "") {
        return callback(new Error(this.$t("tips.pwdTips")));
      } else {
        if (!yanzheng) {
          return callback(
            new Error(
              this.$t("tips.pwdTips")
            )
          );
        } else if (this.pawform.newPassword2 !== "") {
          this.$refs.pawform.validateField("newPassword2");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      var yanzheng = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,}$/.test(
        value
      );
      if (value === "") {
        return callback(new Error(this.$t("tips.enterAgain")));
      } else if (value !== this.pawform.newPassword) {
        return callback(new Error(this.$t("tips.twoPawNotSanme")));
      } else if (!yanzheng) {
        return callback(
          new Error(
            this.$t("tips.pwdTips")
          )
        );
      } else {
        callback();
      }
    };
    var validatePass3 = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error(this.$t("tips.needed")));
      } else {
        callback();
      }
    };
    return {
      rules: {
        currentPassword: [{ validator: validatePass3, trigger: "blur" }],
        newPassword: [{ validator: validatePass1, trigger: "blur" }],
        newPassword2: [{ validator: validatePass2, trigger: "blur" }],
      },
      pawform: {
        username: "",
        currentPassword: "",
        newPassword: "",
        newPassword2: "",
      },
    };
  },
  async mounted() {
    this.openNotice();
    this.getUserName();
  },
  methods: {
    getUserName() {
      this.pawform.username = getItemFormLocalstorage("userName");
    },
    openNotice() {
      let changeCode = localStorage.getItem('isneedchange');
      let warnMessage = "";
      if (changeCode == 501) {
        warnMessage = this.$t("pwdTips.change501");
        this.$message({
          title: "警告",
          message: warnMessage,
          type: "warning",
        });
      } else if (changeCode == 502) {
        warnMessage = this.$t("pwdTips.change502");
        this.$message({
          title: "警告",
          message: warnMessage,
          type: "warning",
        });
      }

    },
    togleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    changePassword() {
      let that = this;
      changePassword(that.pawform)
        .then((res) => {
          let data = res.result;
          that.airoptions = data;
          /*that.$message({
            showClose: true,
            message: "修改成功！",
            type: "success",
          });*/
          that.$alert(that.$t("desc.PasswordModifiedSuccessfully"), this.$t("title.tips"), {
            confirmButtonText: this.$t("button.confirm"),
            callback: (action) => {
              that.$router.push({
                path: "/clientlogin",
              });
            },
            close: (action) => {
              that.$router.push({
                path: "/clientlogin",
              });
            },
          });
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: that.$t("pwdTips." + err.error.message),
            type: "error",
          });
        });
    },
    onSubmit(value) {
      let that = this;
      that.$refs[value].validate((valid) => {
        if (valid) {
          that.changePassword();
        } else {
          return false;
        }
      });
    },
    back() {
      this.$router.back();
    }
  },
  computed: mapState({
    isCollapse: (state) => state.isCollapse,
    navselected: (state) => state.adminleftnavnum,
  }),
};
</script>

<style scope>
.theme1 .index {
  padding: 20px !important;
}

.index {
  position: relative !important;
}

.queryform_div .el-form-item {
  margin-top: 20px !important;
}

.theme1 .el-breadcrumb__inner a,
.theme1 .el-breadcrumb__inner.is-link {
  color: #fff;
}
</style>
